import { HwToken } from "@app/interfaces/Token";
import SessionStorage from "./SessionStorage"
import jwt_decode from 'jwt-decode';
import LocalStorage from "./LocalStorage";

export default class LicenceOptions {
  public static get  HasExiLicence() : boolean {
    let token : string;
    if( LocalStorage.IsTabletMode) {
      if( LocalStorage.OperationMode == "VIP") {
        token  = SessionStorage.GuestData.Token

      } else {
        token = LocalStorage.TabletToken;
      }
    } else {
      token  = SessionStorage.GuestData.Token
    }
    const decodedToken = jwt_decode(token) as HwToken
    return decodedToken.ExiOptions.includes("EXI") ? true : false
    
  }

  public static get HasExoLicence() : boolean {
    let token : string;
    if( LocalStorage.IsTabletMode) {
      if( LocalStorage.OperationMode == "VIP") {
        token  = SessionStorage.GuestData.Token

      } else {
        token = LocalStorage.TabletToken;
      }
    } else {
      token  = SessionStorage.GuestData.Token
    }
    const decodedToken = jwt_decode(token) as HwToken
    return decodedToken.ExiOptions.includes("EXO") ? true : false
  }
}